const types = {
    CREATE_SURVEY_FORM: "CREATE_SURVEY_FORM",
    CREATE_SURVEY_FORM_RESPONSE: "CREATE_SURVEY_FORM_RESPONSE",
    CREATE_SURVEY_FORM_CLEAR: "CREATE_SURVEY_FORM_CLEAR",
    
    FETCH_SURVEY_FORM: "FETCH_SURVEY_FORM",
    FETCH_SURVEY_FORM_RESPONSE: "FETCH_SURVEY_FORM_RESPONSE",
    FETCH_SURVEY_FORM_CLEAR: "FETCH_SURVEY_FORM_CLEAR",

    SUBMIT_SURVEY_FORM: "SUBMIT_SURVEY_FORM",
    SUBMIT_SURVEY_FORM_RESPONSE: "SUBMIT_SURVEY_FORM_RESPONSE",
    SUBMIT_SURVEY_FORM_CLEAR: "SUBMIT_SURVEY_FORM_CLEAR",
}

export default types